<template>
    <div class="card product-simple-card">
        <div class="product-image-container">
            <div class="product-image" :class="{ unavailable: product.media === null }"
                 :style="'background-image: url(' + (product.media.length ? product.media[0].fullUrl : './assets/images/icons/no-image.png') + ')'">
            </div>
        </div>
        <div class="card-body m-3 text-center">
            <h4 class="card-title">{{ product.meta.title }}</h4>
            <h6 class="model-title">{{ product.model }}</h6>
            <template v-if="fareHarborMode()">
                <a href="javascript:void(0)" class="btn btn-primary" @click="openFareHarborModal()">Buy now</a>
            </template>
            <template v-else>
                <a :href="'/' + pageSlug + '/' + product.slug" class="btn btn-primary">Buy now</a>
                <a :href="'/' + pageSlug + '/' + product.slug" class="btn btn-outline-dark">Bike specs</a>
            </template>
        </div>
    </div>
</template>

<script>
import FareHarborMixin from "../../../mixins/FareHarborMixin";

export default {
    name: "ProductSimpleCard",
    mixins: [FareHarborMixin],
    props: {
        product: {
            required: true
        },
        pageSlug: {
            type: String,
            default: 'specifications'
        }
    }
}
</script>

<style scoped>

</style>
